/**
 * InlineScriptRunner
 * Führt Script-Tags in dynamisch geladenem HTML erneut aus,
 * damit Contao-Inhalte korrekt funktionieren.
 */
export default class InlineScriptRunner {
  /**
   * @param {HTMLElement} context - Container mit Script-Tags
   */
  run(context) {
    context.querySelectorAll('script').forEach(oldScript => {
      const s = document.createElement('script');
      s.type = oldScript.type || 'text/javascript';
      if (oldScript.src) {
        s.src = oldScript.src;
      } else {
        s.textContent = oldScript.textContent || '';
      }
      if (oldScript.nonce) s.setAttribute('nonce', oldScript.nonce);
      oldScript.parentNode.replaceChild(s, oldScript);
    });
  }
}
